import React from "react";
import church from "../../../../resources/images/church-group.jpg";
import { useTranslation } from "react-i18next";

const Church = () => {
  const { t } = useTranslation();

  return (
    <div className="container text-relevant text-justify">
      <h1>{t("mount-zion-bible-church")}</h1>
      <p>
        {t("church-p0") + " "}
        <a
          className="btn btn-primary btn-sm"
          href="https://mtzionbiblechurch.org"
          target="_blank"
        >
          MtZionBibleChurch.org
        </a>
      </p>
      <p>{t("church-p1")}</p>
      <div style={{ textAlign: "center" }}>
        <img
          className="img-thumbnail"
          src={church}
          alt="church"
          style={{ "--aspect-ratio": "690/151" }}
        />
      </div>
      <b>{t("church-p2")}</b>
      <table>
        <thead>
          <tr>
            <td style={{ width: "150px" }}>{t("church-p3")}</td>
            <td>10:30 AM</td>
          </tr>
          <tr>
            <td>{t("church-p4-a")}</td>
            <td>6:00 PM {t("church-p4-b")}</td>
          </tr>
        </thead>
      </table>
      <br />
      <p>
        <span>
          <b>{t("london-baptist-confesion-of-1689")}: </b>
        </span>
        <span dangerouslySetInnerHTML={{ __html: t("doctrine-p1") }}></span>
      </p>
      <p>
        <b>{t("directions")}:</b> {t("church-p5")}
      </p>
      <p>
        <b>{t("church-p6-a")}:</b> {t("church-p6-b")}
      </p>
    </div>
  );
};

export default Church;
